import ResponsiveSlider from '../slider';
import "./index.css";



export default function BasicTabs({tabFields}) {
 

 



  return (
    <div style={{ width: '100%',maxWidth:'100vw',overflow:'hidden' }}>
      {tabFields?.map((tab, index) => {
        return (
          <div key={index}>
            <div className='font-Inter '>
              <h2 className='text-[18px] my-[40px] font-[600] text-black  text-center'>{tab?.heading}</h2>
            </div>

            <div className='w-[95%] mx-auto my-4'>
              {tab?.filters && <div className='px-1 sm:px-2'>
                {tab.filters}

              </div>}
              <ResponsiveSlider data={tab?.data} bestSeller={tab?.bestSeller} />

            </div>
          </div>
        )
      })}


    </div>
  );
}
